// TODO(kristjan): consider caching Intl.NumberFormat objects if used on tables/lists
export function formatNumber(locale: string, input: number, isCurrency: boolean, useGrouping: boolean): string;
export function formatNumber(locale: string, input: null | undefined, isCurrency: boolean, useGrouping: boolean): null;
export function formatNumber(
  locale: string,
  input: null | undefined | number,
  isCurrency: boolean,
  useGrouping: boolean,
): null | string;
export function formatNumber(
  locale: string,
  input: null | undefined | number,
  isCurrency: boolean,
  useGrouping: boolean,
): null | string {
  if (input == null) {
    return null;
  } else {
    return new Intl.NumberFormat(locale, {
      useGrouping: useGrouping,
      minimumFractionDigits: isCurrency ? 2 : 0,
    }).format(input);
  }
}
